module.exports = __webpack_public_path__ + "static/img/y3_6.38a906c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/y3_6.jpg
// module id = /poh
// module chunks = 0